import type { Mutation, ActionContext, Getter } from 'vuex'
import type { UserLoginInformationModel } from '@/api/system/model/userLoginInformationModel'

import actionTypes from './actionTypes'

export { actionTypes }

export interface LoginUserState {
  userInfo: UserLoginInformationModel | null
  registeredCorporatorsInfo: UserLoginInformationModel[]
}

const state: LoginUserState = {
  userInfo: null,
  registeredCorporatorsInfo: [],
}

interface LoginUserGetter {
  [getter: string]: Getter<LoginUserState, any>
}

const getters: LoginUserGetter = {}

interface LoginUserMutation {
  [mutationType: string]: Mutation<LoginUserState>
}

const mutations: LoginUserMutation = {
  [actionTypes.SET_USER_INFO](
    state: LoginUserState,
    userInfo: UserLoginInformationModel
  ): void {
    state.userInfo = userInfo
  },

  [actionTypes.SET_REGISTERED_CORPORATORS_INFO](
    state,
    corporators: UserLoginInformationModel[]
  ): void {
    state.registeredCorporatorsInfo = corporators
  },
}

interface LoginUserActions {
  [actionType: string]: (
    injectee: ActionContext<LoginUserState, any>,
    payload: any
  ) => void
}

const actions: LoginUserActions = {
  [actionTypes.SET_USER_INFO]: ({ commit }, userInfo: UserLoginInformationModel) => {
    commit(actionTypes.SET_USER_INFO, userInfo)
  },

  [actionTypes.SET_REGISTERED_CORPORATORS_INFO](
    { commit },
    corporators: UserLoginInformationModel[]
  ): void {
    commit(actionTypes.SET_REGISTERED_CORPORATORS_INFO, corporators)
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
